import React, { useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "../../../helper/axios";

const CreateUserForm = ({ onClose }) => {
  const { token } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("");

  const handleCreateUser = async (event) => {
    event.preventDefault();
    const userData = {
      user_name: username,
      user_email: email,
      user_password: password,
      user_type: type,
    };

    try {
      // Use axios to create a user with admin privileges
      const response = await axios.post("/maitri_register", userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Handle success response
      alert("User Created Successfully");
      console.log("User created:", response.data);

      // Reset form fields
      setUsername("");
      setEmail("");
      setPassword("");
      setType("");
    } catch (error) {
      console.error("Error creating user:", error);
      // Handle error response
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="addUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addUserModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form onSubmit={handleCreateUser} className="form">
              <h2>Create User</h2>
              <div className="my-3">
                <label className="form-label">Username:</label>
                <input
                  className="form-control"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="my-3">
                <label className="form-label">Email:</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="my-3">
                <label className="form-label">Password:</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="my-3">
                <label className="form-label">User Type:</label>
                <input
                  type="text"
                  className="form-control"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                />
              </div>
              {/* <button type="submit" className="btn btn__outline my-2">
                Create
              </button> */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn__outline">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateUserForm;
